
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"150","height":"100","viewBox":"0 0 150 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 7C14 3.13401 17.134 0 21 0H43.0071C45.6585 0 48.0823 1.49802 49.2681 3.86951L53.7319 12.7972C54.9177 15.1687 57.3415 16.6667 59.9929 16.6667H143C146.866 16.6667 150 19.8007 150 23.6667V93C150 96.866 146.866 100 143 100H21C17.134 100 14 96.866 14 93V7Z","fill":"#B9DEFA"}}),_c('path',{attrs:{"d":"M0 7C0 3.13401 3.13401 0 7 0H29.0071C31.6585 0 34.0823 1.49802 35.2681 3.86951L39.7319 12.7972C40.9177 15.1687 43.3415 16.6667 45.9929 16.6667H143C146.866 16.6667 150 19.8007 150 23.6667V93C150 96.866 146.866 100 143 100H7C3.13401 100 0 96.866 0 93V7Z","fill":"#E0F2FE"}})])
          )
        }
      }
    